import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as AuthActions from './auth.actions';
import * as fromAuth from './auth.reducers';
import * as AuthSelectors from './auth.selectors';
import { NewCustomerDTO } from '@care-portals/api-interfaces';
import { filter, tap } from 'rxjs/operators';

@Injectable()
export class AuthFacade {
  isAuthenticated$ = this.store.pipe(
    select(AuthSelectors.getIsAuth),
    filter(val => val !== null)
  );

  authState$ = this.store.pipe(select(AuthSelectors.getAuthState));
  user$ = this.store.pipe(
    select(AuthSelectors.getUser),
    filter(user => !!user)
  );
  isCheckoutFlow$ = this.store.pipe(select(AuthSelectors.isCheckoutFlow));
  redirectUrl$ = this.store.pipe(select(AuthSelectors.getRedirectUrl));
  isLoading$ = this.store.pipe(select(AuthSelectors.isLoading));
  errorMessage$ = this.store.pipe(select(AuthSelectors.errorMessage));
  forgotPasswordSuccess$ = this.store.pipe(
    select(AuthSelectors.getForgotPasswordSuccess)
  );

  constructor(private store: Store<fromAuth.State>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  validateAuth() {
    this.dispatch(AuthActions.validateAuth());
  }

  whenUserReady() {
    return this.store
      .select(AuthSelectors.getUser)
      .pipe(filter(val => val !== null));
  }

  login(username: string, password: string) {
    this.store.dispatch(
      AuthActions.logIn({
        username,
        password
      })
    );
  }

  logOut() {
    this.store.dispatch(AuthActions.logOut());
  }

  signUp(newCustomerDTO: NewCustomerDTO) {
    this.store.dispatch(AuthActions.signUp({ newCustomerDTO }));
  }

  forgotPassword(username: string) {
    this.dispatch(AuthActions.forgotPassword({ username }));
  }

  validPasswordToken(token: string) {
    this.dispatch(AuthActions.validPasswordToken({ token }));
  }

  resetPassword(token: string, password: string) {
    this.dispatch(AuthActions.resetPassword({ token, password }));
  }

  loginWithVerifyToken(token: string) {
    this.dispatch(AuthActions.loginWithVerifyLink({ verifyToken: token }));
  }
}
